export const getLocalStorage = (key: string) => {
  return JSON.parse(localStorage.getItem(key) || '{}')
}

export const setLocalStorage = (key: string, value: string | Record<string, any>) => {
  localStorage.setItem(key, JSON.stringify(value))
}
